<template>
  <div>
    <template>
      <!-- 复核工单按钮 -->
      <el-button v-if="isReviewPage()"
                 v-permission="104"
                 type="warning"
                 size="mini"
                 @click="reviewAuditQuality()">
        复核工单
      </el-button>
      <!-- 查看复核结果按钮 -->
      <el-button v-if="isViewPage()"
                 v-permission="104"
                 type="warning"
                 size="mini"
                 @click="viewReviewResult()">
        查看复核结果
      </el-button>
    </template>

    <!-- 审核复核结果反馈弹窗 -->
    <el-dialog :visible.sync="reviewDialogVisible"
               title="审单复核结果反馈"
               width="60%"
               top="10vh"
               :modal-append-to-body="true"
               :append-to-body="true">
      <el-form ref="reviewForm"
               :model="reviewForm"
               label-width="80px">
        <el-form-item label="复核人">
          <span>{{ getReviewer() }}</span>
        </el-form-item>
        <el-form-item label="复核结论"
                      prop="review_status">
          <el-select class="width-max"
                     :disabled="isViewPage()"
                     v-model="reviewForm.review_status"
                     placeholder="请选择">
            <el-option v-for="item in reviewStatusOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="异常题目"
                      prop="wrong_questions">
          <el-select class="width-max"
                     v-if="!isViewPage()"
                     v-model="reviewForm.wrong_questions"
                     multiple
                     placeholder="请选择异常题目"
                     value-key="id">
            <el-option v-for="(question, index) in questionList"
                       :key="question.id"
                       :label="formatQuestionLabel(index, question.title)"
                       :value="{ id: question.id, label: formatQuestionLabel(index, question.title) }">
            </el-option>
          </el-select>
          <div v-else
               class="question-labels">
            <div v-for="(question, index) in reviewForm.wrong_questions"
                 :key="index"
                 class="question-label-item">
              {{ question.label }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="复核备注"
                      prop="remarks">
          <el-input v-model="reviewForm.remarks"
                    :disabled="isViewPage()"
                    type="textarea"
                    placeholder="请输入"
                    rows="3">
          </el-input>
        </el-form-item>
        <el-form-item>
          <div class="form-tip">
            <span style="color: #999;">复核说明：针对业务组长或负责人进行复核，复核结果针对性给实习生审单问题情况反馈，且关键用于计算审单实习生绩效分。</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <template v-if="isReviewPage()">
          <el-button @click="reviewDialogVisible = false">取消</el-button>
          <el-button type="primary"
                     @click="submitReview">确认</el-button>
        </template>
        <template v-else>
          <el-button type="primary"
                     @click="reviewDialogVisible = false">关闭</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QuestionReview from '@views/question-review/question-review.js'
import orderReviewValidate from '@views/order-review/mixins/order-review-validate.mixin.js'
import { reviewStatusMap } from '@views/task/review-task.mixins.js'

export default {
  components: {},
  mixins: [orderReviewValidate],
  inject: ['page'],
  props: {
    id: [Number, String],
  },
  data () {
    return {
      reviewStatusMap,
      reviewDialogVisible: false,
      reviewForm: {
        reviewer: '',
        review_status: '',
        abnormalReason: '',
        remarks: '',
        wrong_questions: [],
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      loginUser: state => state.login.user,
      orderDetail: state => state.orderReview.orderDetail,
      sjfOrderDetail: state => state.orderReview.sjfOrderDetail,
    }),
    questionList () {
      return _.get(this, 'page.questions', [])
    },
    reviewStatusOptions () {
      return Object.entries(this.reviewStatusMap)
        .map(([value, label]) => ({label, value: Number(value)}))
        .filter(item => item.value > 0)
    },
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    isReviewPage () {
      return this.$route.meta.pageType === 'reviewAuditQuality'
    },
    isViewPage () {
      return this.$route.meta.pageType === 'viewReviewAuditQuality'
    },
    getReviewer () {
      if (this.isReviewPage()) {
        return this.loginUser.name + ' / ' + this.loginUser.id
      }
      return this.reviewForm.adminname + ' / ' + this.reviewForm.adminid
    },
    formatQuestionLabel (index, title) {
      const prefix = 'Q' + (index + 1) + ' '
      const maxLength = 120
      const fullText = prefix + title
      if (fullText.length > maxLength) {
        return fullText.substring(0, maxLength) + '...'
      }
      return fullText
    },
    async reviewAuditQuality () {
      try {
        await this.checkAnswerBeforeSave()
        this.reviewDialogVisible = true
      } catch (error) {
        // 校验失败时，校验方法内部已弹出提示，这里直接中断即可
        if (error && error.message && error.message !== '校验未通过') {
          this.$message.error(error.message)
        }
      }
    },
    /**
     * SJF 校验失败后，由 `checkSJFOrderValid()` 调用继续校验答案合法性。
     * 该组件的行为是：触发校验提示后，不再继续打开复核弹窗。
     */
    executeAnswerValidation () {
      // 让 validateAnswer 自己负责弹窗提示；通过后打开复核弹窗。
      return this.validateAnswer()
        .then(() => {
          this.reviewDialogVisible = true
        })
        .catch(() => {})
    },
    async viewReviewResult () {
      request.common('getReviewAuditQualityApi', {id: this.page.id}).then(({data}) => {
        this.reviewForm = data
        this.reviewDialogVisible = true
      })
    },
    async submitReview () {
      // 验证表单
      await this.$refs.reviewForm.validate(async (valid) => {
        if (valid) {
          try {
            // 提交复核结果
            const params = {
              id: this.id,
              order_id: this.id,
              review_status: this.reviewForm.review_status,
              remarks: this.reviewForm.remarks,
              wrong_questions: this.reviewForm.wrong_questions,
              answerChangeTotal: this.page.answerChangeTotal,
              review_tpl_resultjson: JSON.stringify(QuestionReview().getRecoveryAnswers(this.page)),
            }
            // 调用复核 API
            await request('reviewAuditQualityApi', params)
            // 显示成功消息
            this.$message.success('复核成功')
            this.reviewDialogVisible = false

            this.$confirm('是否继续复核下一个分配给您的任务？').then(() => {
              request.common('queryReviewTaskTableApi', {
                adminid: this.loginUser.id,
                review_status: 0,
                current_page: 1,
                per_page: 1,
              }).then((res) => {
                const nextOrderId = _.get(res, 'data.data.0.orderid')
                if (nextOrderId > 0) {
                  this.$router.push({path: '/order/review-audit-quality/' + nextOrderId})
                } else {
                  this.$alert('分配给您的复核任务已全部完成,无更多的待复审工单', '提示', {type: 'error'})
                }
              })
            })
          } catch (error) {
            this.$message.error('复核结果保存失败：' + (error.message || '未知错误'))
          }
        }
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
.form-tip {
  margin-top: 10px;
  margin-left: -10px;
  font-size: 12px;
  line-height: 1.4;
}

.question-labels {
  padding: 4px 8px;
  background: #f5f7fa;
  border-radius: 4px;
  min-height: 32px;
}

.question-label-item {
  padding: 2px 0;
  font-size: 13px;
  color: #606266;
  line-height: 1.7;
  word-break: break-all;

  &:not(:last-child) {
    border-bottom: 1px solid #ebeef5;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/ReviewAuditQualityButton.vue